import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import normalize from "json-api-normalizer";
import { mergeMap } from "rxjs/operators";
import { push } from "react-router-redux";
import { notification } from "antd";
import { parseError } from "./lib";
import { empty } from "rxjs";

import TaskService from "../services/taskService";

import { insertPatientProgramItemRequest } from "../ducks/patient";
import {
  LOAD_TASKS_REQUEST_ACTION,
  loadTasksSuccess,
  loadTasksFailure,
  SAVE_TASK_REQUEST_ACTION,
  SAVE_TASK_SUCCESS_ACTION,
  SAVE_TASK_FAILURE_ACTION,
  saveTaskFailure,
  saveTaskSuccess,
  DELETE_TASK_REQUEST_ACTION,
  deleteTaskFailure,
  deleteTaskSuccess,
  saveTaskRequest,
  insertProgramItemRequest
} from "../ducks/data";

import { setActiveDialog, addSubmitForm } from "../ducks/app";

import {
  saveTaskFormSuccess,
  saveTaskFormFailure,
  SAVE_TASK_FORM_REQUEST_ACTION,
  SAVE_PATIENT_TASK_FORM_REQUEST_ACTION,
  savePatientTaskFormFailure
} from "../ducks/task";
import { insertPatientProgramItemEpic } from "./patients";

const _ = require("lodash");

export const loadTasksEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_TASKS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let taskService = new TaskService();
      return taskService
        .findAll(action.payload)
        .then(response => {
          return loadTasksSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadTasksFailure(parseError(error));
        });
    })
  );

export const saveTaskFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return concat(
        of(saveTaskRequest(action.payload)),
        of(addSubmitForm(action.payload))
      );
    })
  );

export const saveTaskFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      const tasks = action.payload.task;
      let task = tasks.tasks[Object.keys(tasks.tasks)[0]];
      task.formPristine = true;
      return concat(
        of(saveTaskFormSuccess(action.payload.task)),
        of(addSubmitForm(task))
      );
    })
  );

export const saveTaskFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveTaskFormFailure(action.payload));
    })
  );

export const saveTaskEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new TaskService();
      return concat(
        service
          .save(action.payload)
          .then(response => {
            return saveTaskSuccess(normalize(response.data));
          })
          .catch(error => {
            return saveTaskFailure(parseError(error));
          })
      );
    })
  );

export const deleteTaskEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_TASK_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new TaskService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteTaskSuccess(action.payload);
          })
          .catch(error => {
            return deleteTaskFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );

export const savePatientTaskFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_PATIENT_TASK_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new TaskService();
      let patientProgramId = action.payload.patientProgramId;
      return service
        .save(action.payload)
        .then(response => {
          let task = response.data.data;
          let item = {
            attributes: {
              name: task.attributes.name,
              taskId: task.id,
              patientProgramId: patientProgramId,
              essential: task.attributes.informedConsent
            },
            relationships: {
              task: { id: task.id },
              patientProgram: { id: patientProgramId }
            },
            type: "patientProgramItems"
          };

          return insertPatientProgramItemRequest(item);
        })
        .catch(error => {
          return savePatientTaskFormFailure(parseError(error));
        });
    })
  );

export const savePatientTaskFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return of(saveTaskFormSuccess(action.payload));
    })
  );

export const savePatientTaskFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_TASK_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveTaskFormFailure(action.payload));
    })
  );



// WEBPACK FOOTER //
// ./src/epics/tasks.js